/* 
    Credit: https://inclusive-components.design/tabbed-interfaces/
    The code is modified from it's original source. 
*/

(() => {
    enum Orientation {
        Horizontal = 'horizontal',
        Vertical = 'vertical',
    }

    enum KeyboardDirections {
        Next = 'next',
        Previous = 'previous',
        Down = 'down'
    }

    const tabbed = document.querySelectorAll('.tabbed') as NodeListOf<HTMLElement>;

    if (tabbed !== null) {

        tabbed.forEach((tab) => {
            const tablist = tab.querySelector('ul') as HTMLUListElement;
            const tabs = tablist.querySelectorAll('a') as NodeListOf<HTMLAnchorElement>;
            const panels = document.querySelectorAll('[id^="section"]') as NodeListOf<HTMLElement>;
            let tabOrientation = Orientation.Horizontal;

            // The tab switching function
            const switchTab = (oldTab: HTMLAnchorElement, newTab: HTMLAnchorElement) => {
                newTab.focus();
                // Make the active tab focusable by the user (Tab key)
                newTab.removeAttribute('tabindex');
                // Set the selected state
                newTab.setAttribute('aria-selected', 'true');
                oldTab.setAttribute('aria-selected', 'false');
                oldTab.setAttribute('tabindex', '-1');
                // Get the indices of the new and old tabs to find the correct
                // tab panels to show and hide
                let index = Array.prototype.indexOf.call(tabs, newTab);
                let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
                (panels[oldIndex] as HTMLElement).hidden = true;
                (panels[index] as HTMLElement).hidden = false;
            }

            // Add the tablist role to the first <ul> in the .tabbed container
            tablist.setAttribute('role', 'tablist');

            // Create the query list for our "mobile" breakpoint.
            const mediaQueryList: MediaQueryList = window.matchMedia("(max-width: 768px)");

            // Define a callback function for the event listener.
            function handleViewportChange(mql: MediaQueryList) {
                // If the tablist element is vertically oriented, it has the property aria-orientation set to vertical.
                // The default value of aria-orientation for a tablist element is horizontal.
                if (mql.matches) {
                    tabOrientation = Orientation.Vertical;
                    tablist.setAttribute('aria-orientation', Orientation.Vertical);
                }
                else {
                    tabOrientation = Orientation.Horizontal;
                    tablist.setAttribute('aria-orientation', Orientation.Horizontal);
                }
            }

            // Run the viewport change handler once.
            handleViewportChange(mediaQueryList);

            // Add the callback function as a listener to the query list.
            mediaQueryList.addEventListener("change", () => handleViewportChange(mediaQueryList));



            // Add semantics and remove user focusability for each tab
            Array.prototype.forEach.call(tabs, (tab: HTMLAnchorElement, i: number) => {
                tab.setAttribute('role', 'tab');
                tab.setAttribute('id', 'tab' + (i + 1));
                tab.setAttribute('tabindex', '-1');
                // Each element with role tab has the property aria-controls referring to its associated tabpanel element.
                tab.setAttribute('aria-controls', panels[i].id)
                if (i > 0) {
                    // The active tab element has the state aria-selected set to true and all other tab elements have it set to false.
                    tab.setAttribute('aria-selected', 'false');
                }
                (tab.parentNode as HTMLElement).setAttribute('role', 'presentation');

                // Handle clicking of tabs for mouse users
                tab.addEventListener('click', (e: MouseEvent) => {
                    e.preventDefault();
                    let currentTab = tablist.querySelector('[aria-selected="true"]') as HTMLAnchorElement;
                    if (e.currentTarget !== currentTab) {
                        switchTab(currentTab, e.currentTarget as HTMLAnchorElement);
                    }
                });

                // Handle keydown events for keyboard users
                tab.addEventListener('keydown', (e: KeyboardEvent) => {
                    // Get the index of the current tab in the tabs node list
                    let index: number = Array.prototype.indexOf.call(tabs, e.currentTarget);
                    // Work out which key the user is pressing and
                    // Calculate the new tab's index where appropriate
                    let dir: KeyboardDirections | null;
                    if (tabOrientation === Orientation.Horizontal) {
                        dir = e.key === 'ArrowLeft' ? KeyboardDirections.Previous : e.key === 'ArrowRight' ? KeyboardDirections.Next : e.key === 'ArrowDown' ? KeyboardDirections.Down : null;
                    } else {
                        dir = e.key === 'ArrowUp' ? KeyboardDirections.Previous : e.key === 'ArrowDown' ? KeyboardDirections.Next : e.key === 'ArrowRight' ? KeyboardDirections.Down : null;
                    }

                    // Get the new selected tabs index.
                    let newIndex = index;
                    if (dir === KeyboardDirections.Next) {
                        newIndex = index + 1;
                        if (newIndex > tabs.length - 1) {
                            // If focus is on the last tab element, moves focus to the first tab.
                            newIndex = 0;
                        }
                    } else if (dir === KeyboardDirections.Previous) {
                        newIndex = index - 1;
                        if (newIndex < 0) {
                            // If focus is on the first tab, moves focus to the last tab. 
                            newIndex = tabs.length - 1;
                        }
                    }

                    if (dir !== null) {
                        e.preventDefault();
                        // If the down key is pressed, move focus to the open panel,
                        // otherwise switch to the adjacent tab
                        dir === KeyboardDirections.Down
                            ? (panels[i] as HTMLElement).focus() : tabs[newIndex] ? switchTab(e.currentTarget as HTMLAnchorElement, tabs[newIndex] as HTMLAnchorElement) : void 0;
                    }
                });
            });

            // Add tab panel semantics and hide them all
            Array.prototype.forEach.call(panels, (panel: HTMLElement, i: number) => {
                panel.setAttribute('role', 'tabpanel');
                panel.setAttribute('tabindex', '-1');
                panel.setAttribute('aria-labelledby', tabs[i].id);
                panel.hidden = true;
            });

            const params = new URLSearchParams(window.location.search);

            // Initially activate the first tab and reveal the first tab panel
            if (params.has("subtype") && params.get("subtype") == "Händelse") {
                (tabs[1] as HTMLAnchorElement).removeAttribute('tabindex');
                (tabs[1] as HTMLAnchorElement).setAttribute('aria-selected', 'true');
                (panels[1] as HTMLElement).hidden = false;
            } else {
                (tabs[0] as HTMLAnchorElement).removeAttribute('tabindex');
                (tabs[0] as HTMLAnchorElement).setAttribute('aria-selected', 'true');
                (panels[0] as HTMLElement).hidden = false;
            }
        });
    }
})();